module.exports = __webpack_public_path__ + "img/2a9dd70.png";